import { Link } from "react-router-dom";

import { useLatestDownload } from "../useLatestDownload";

/** The banner is outside the two branches below, so the page has its heading —
 * and says whose case this is — whether or not the release metadata loads. */
function DownloadBanner() {
  return (
    <section className="page-banner page-banner--download marketing__bleed">
      <div className="page-header bleed-inner">
        <h1>Download Big Bear Backup for Windows</h1>
        <p className="banner-line">Put Big Bear on the case.</p>
      </div>
    </section>
  );
}

export function Download() {
  const download = useLatestDownload();

  if (!download) {
    return (
      <>
        <DownloadBanner />
        <div className="empty empty--error" role="alert">
          <h2>Could not load the latest release</h2>
          <p className="muted">
            No release notes are published yet — try the{" "}
            <Link to="/releases">releases page</Link>.
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <DownloadBanner />
      <section className="panel download">
        <p className="muted">
          Version {download.version} — {download.headline} · Released {download.date} ·{" "}
          <Link to={`/releases/${download.version}`}>Full release notes →</Link>
        </p>

        {download.status === "building" && (
          <p className="download__building" role="status">
            v{download.version}'s installers are still building. The links below may still point at
            the previous release for a few more minutes — refresh to check.
          </p>
        )}

        <div className="download__actions">
          <a className="button button--primary" href={download.nsisUrl}>
            Download for Windows (recommended)
          </a>
          <a className="button" href={download.msiUrl}>
            Download MSI installer
          </a>
        </div>

        {(download.nsisSha256 || download.msiSha256) && (
          <p className="muted mono download__checksums">
            {download.nsisSha256 && <>installer sha256: {download.nsisSha256}</>}
            {download.nsisSha256 && download.msiSha256 && <br />}
            {download.msiSha256 && <>msi sha256: {download.msiSha256}</>}
          </p>
        )}

        <p className="muted download__note">
          Windows SmartScreen may warn on first run — the installer is signed for the
          auto-updater, but not yet with a Windows Authenticode certificate. Choose{" "}
          <strong>More info</strong> → <strong>Run anyway</strong>.
        </p>

        <p className="muted download__note">
          The app checks for updates on its own and can install them automatically or just let you
          know — your choice, in Settings once it's installed.
        </p>

        <p className="muted download__note">
          Choosing a destination? <Link to="/providers">Providers, threads and pack size</Link>{" "}
          compares what each one costs and how to tune it.
        </p>
      </section>
    </>
  );
}
